import React from 'react';

import './LanguesParlees.css';
import './LanguesParlees.mobile.css';


const DATA_LANGUES = [
    {
        key: 'francais',
        label: 'Français',
        iso: 'FR',
        niveau: 'Maternelle',
        id: 'LNG-01',
        competences: [
            'Négociation critique',
            'Rédaction technique',
            'Pédagogie'
        ],
        code: 'FRA-001-NAT',
        years: '25+'
    },
    {
        key: 'anglais',
        label: 'English',
        iso: 'EN',
        niveau: 'C1 Advanced',
        id: 'LNG-02',
        competences: [
            'Lead technical meetings',
            'Documentation',
            'International relations'
        ],
        code: 'ENG-002-C1',
        years: '15+'
    },
    {
        key: 'espagnol',
        label: 'Español',
        iso: 'ES',
        niveau: 'C1 Advanced',
        id: 'LNG-03',
        competences: [
            'Fluidité orale',
            'Multiculturel',
            'Traduction live'
        ],
        code: 'ESP-003-C1',
        years: '10+'
    },
    {
        key: 'italien',
        label: 'Italiano',
        iso: 'IT',
        niveau: 'B2 Upper-Int',
        id: 'LNG-04',
        competences: [
            'Communication courante',
            'Gestion projet',
            'Compréhension'
        ],
        code: 'ITA-004-B2',
        years: '5+'
    },
    {
        key: 'portugais',
        label: 'Português',
        iso: 'PT',
        niveau: 'B2 Upper-Int',
        id: 'LNG-05',
        competences: [
            'Échanges pro',
            'Lecture docs',
            'Communication écrite'
        ],
        code: 'POR-005-B2',
        years: '4+'
    },
    {
        key: 'russe',
        label: 'Русский',
        iso: 'RU',
        niveau: 'A1 Beginner',
        id: 'LNG-06',
        competences: [
            'Alphabet Cyrillique',
            'Bases grammaire',
            'Phrases simples'
        ],
        code: 'RUS-006-A1',
        years: '1+'
    }
];


const LanguesParlees = () => {

    return (
        <section
            className="langues-parlees-dossier-root"
            aria-labelledby="langues-parlees-title"
        >

            <header className="langues-parlees-hero-header">

                <div className="langues-parlees-header-container">

                    <div className="langues-parlees-title-block">

                        <h1
                            id="langues-parlees-title"
                            className="langues-parlees-main-title"
                        >
                            MATRICE LINGUISTIQUE
                        </h1>

                        <p className="langues-parlees-header-accent">
                            COMMUNICATION MULTILINGUE · 6 LANGUES · PORTÉE INTERNATIONALE
                        </p>

                    </div>

                </div>

            </header>


            <main className="langues-parlees-grid-viewport">

                <div
                    className="langues-parlees-grid-3x2"
                    role="region"
                    aria-label="Langues parlées"
                >

                    {DATA_LANGUES.map((lang) => (

                        <article
                            key={lang.key}
                            className={`
                                langues-parlees-compact-card
                                langues-parlees-card-${lang.key}
                            `}
                        >

                            <div className="langues-parlees-card-identity">

                                <div className="langues-parlees-card-id-row">

                                    <span className="langues-parlees-id-badge">
                                        {lang.id}
                                    </span>

                                    <span className="langues-parlees-years-tag">
                                        EXP_{lang.years}
                                    </span>

                                </div>

                                <h2 className="langues-parlees-lang-label">
                                    {lang.label}
                                </h2>

                            </div>


                            <div className="langues-parlees-card-body">

                                <div className="langues-parlees-level-indicator">
                                    {lang.niveau}
                                </div>

                                <ul className="langues-parlees-skill-stack">

                                    {lang.competences.map((skill, index) => (

                                        <li
                                            key={index}
                                            className="langues-parlees-skill-row"
                                        >
                                            <span
                                                className="langues-parlees-bullet-square"
                                                aria-hidden="true"
                                            />

                                            <span>
                                                {skill}
                                            </span>
                                        </li>

                                    ))}

                                </ul>

                            </div>


                            <footer className="langues-parlees-card-technical-footer">

                                <code className="langues-parlees-tech-code">
                                    {lang.code}
                                </code>

                                <span
                                    className="langues-parlees-iso-stamp"
                                    aria-label={`Code langue ${lang.iso}`}
                                >
                                    {lang.iso}
                                </span>

                            </footer>

                        </article>

                    ))}

                </div>

            </main>


            <footer className="langues-parlees-legal-footer">

                <div className="langues-parlees-footer-line" />

                <div className="langues-parlees-footer-content">

                    <span>
                        COMMUNICATION MULTILINGUE · TECH · PROJET · INTERNATIONAL
                    </span>

                    <span>
                        6 LANGUES · NIVEAUX ACTUELS
                    </span>

                </div>

            </footer>

        </section>
    );
};


export default LanguesParlees;